<template>
  <header class="text-white shadow-md" style="background-color: #4e8948;">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8 py-3 sm:py-4">
      <div class="flex justify-between items-center">
        <router-link to="/" class="flex items-center space-x-3 hover:opacity-80 transition-opacity">
          <!-- Logo - voeg logo.svg toe aan public folder om te activeren -->
          <img 
            v-if="logoExists"
            src="/logo.svg" 
            alt="ARHC Logo" 
            class="h-8 w-auto"
            @error="logoExists = false"
          />
          <h1 class="text-2xl sm:text-3xl bg-transparent text-white uppercase" style="font-family: 'Bree Serif', serif;">Studiewijzer</h1>
        </router-link>
        
        <!-- Desktop Navigation -->
        <nav class="hidden md:flex items-center space-x-4">
          <router-link
            v-if="authStore.isStudent"
            to="/"
            class="hover:text-green-200 transition-colors"
          >
            Dashboard
          </router-link>
          <router-link
            v-if="authStore.isStudent"
            to="/vakplanner"
            class="hover:text-green-200 transition-colors"
          >
            Vakplanner
          </router-link>
          <router-link
            v-if="authStore.isStudent"
            to="/weekplanner"
            class="hover:text-green-200 transition-colors"
          >
            Weekplanner
          </router-link>
          <router-link
            v-if="authStore.isTeacher"
            to="/teacher/dashboard"
            class="hover:text-green-200 transition-colors"
          >
            Dashboard
          </router-link>
          <router-link
            v-if="authStore.isTeacher"
            to="/teacher"
            class="hover:text-green-200 transition-colors"
          >
            Vakplanner
          </router-link>
          <router-link
            v-if="authStore.isTeacher"
            to="/teacher/voortgang"
            class="hover:text-green-200 transition-colors"
          >
            Voortgang
          </router-link>
          <div v-if="authStore.user" class="flex items-center space-x-4">
            <span class="text-sm hidden lg:inline">{{ authStore.user.name }}</span>
            <button
              @click="handleLogout"
              class="px-3 py-1 bg-green-700 hover:bg-green-800 rounded transition-colors text-sm"
            >
              Uitloggen
            </button>
          </div>
        </nav>

        <!-- Mobile Menu Button -->
        <button
          @click="mobileMenuOpen = !mobileMenuOpen"
          class="md:hidden p-2 rounded-md hover:bg-green-600 transition-colors"
          aria-label="Toggle menu"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              v-if="!mobileMenuOpen"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16"
            />
            <path
              v-else
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <!-- Mobile Navigation -->
      <nav
        v-if="mobileMenuOpen"
        class="md:hidden mt-4 pb-4 border-t border-green-600 pt-4"
      >
        <div class="flex flex-col space-y-3">
          <router-link
            v-if="authStore.isStudent"
            to="/"
            @click="mobileMenuOpen = false"
            class="hover:text-green-200 transition-colors py-2"
          >
            Dashboard
          </router-link>
          <router-link
            v-if="authStore.isStudent"
            to="/vakplanner"
            @click="mobileMenuOpen = false"
            class="hover:text-green-200 transition-colors py-2"
          >
            Vakplanner
          </router-link>
          <router-link
            v-if="authStore.isStudent"
            to="/weekplanner"
            @click="mobileMenuOpen = false"
            class="hover:text-green-200 transition-colors py-2"
          >
            Weekplanner
          </router-link>
          <router-link
            v-if="authStore.isTeacher"
            to="/teacher/dashboard"
            @click="mobileMenuOpen = false"
            class="hover:text-green-200 transition-colors py-2"
          >
            Dashboard
          </router-link>
          <router-link
            v-if="authStore.isTeacher"
            to="/teacher"
            @click="mobileMenuOpen = false"
            class="hover:text-green-200 transition-colors py-2"
          >
            Vakplanner
          </router-link>
          <router-link
            v-if="authStore.isTeacher"
            to="/teacher/voortgang"
            @click="mobileMenuOpen = false"
            class="hover:text-green-200 transition-colors py-2"
          >
            Voortgang
          </router-link>
          <div v-if="authStore.user" class="pt-2 border-t border-green-600">
            <div class="text-sm mb-2">{{ authStore.user.name }}</div>
            <button
              @click="handleLogout"
              class="w-full text-left px-3 py-2 bg-green-700 hover:bg-green-800 rounded transition-colors text-sm"
            >
              Uitloggen
            </button>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '../../store/auth';

const router = useRouter();
const authStore = useAuthStore();

// Check if logo exists
const logoExists = ref(false);
const mobileMenuOpen = ref(false);

onMounted(() => {
  // Try to load logo to check if it exists
  const img = new Image();
  img.onload = () => {
    logoExists.value = true;
  };
  img.onerror = () => {
    logoExists.value = false;
  };
  img.src = '/logo.svg';
});

const handleLogout = async () => {
  mobileMenuOpen.value = false;
  await authStore.logout();
  // Redirect to login page after logout
  router.push('/login');
};
</script>
